import VueScrollTo from 'vue-scrollto';

export default {
    data() {
        return {
            showUsedOnlyGraphs: false,
            showNewImportGraphs: false,
            csrfToken: Laravel.csrfToken,
            graphImages: '',
            download: '',

            filterYear: null,
            filterComparisonYear: null,
        }
    },

    created() {
        if (this.initialFilters) {
            this.filterYear = _.has(this.initialFilters, 'date.year') ? this.initialFilters.date.year : (new Date()).getFullYear();
            this.filterComparisonYear = _.has(this.initialFilters, 'comparison.year') ? this.initialFilters.comparison.year : (new Date()).getFullYear() - 1;
        }

        if (! this.canViewSalesTypes && this.sources.hasOwnProperty('salesBySalesTypeTable')) {
            delete this.sources.salesBySalesTypeTable;
        }

        this.loadGraphs();
    },

    mounted() {
        bus.$on('filters-updated', function (filters) {
            this.filterYear = filters.date.year;
            this.filterComparisonYear = filters.comparison.year;

            this.filter(filters);
        }.bind(this));

        bus.$on('show-used-only-graphs', () => {
            this.showUsedOnlyGraphs = true;
        });

        bus.$on('show-new-import-graphs', () => {
            this.showNewImportGraphs = true;
        });

        bus.$on('export-dashboard', () => {
           this.exportToPdf();
        });

        _.defer(() => {
            this.scrollToSection();
        })
    },

    props: {
        filterUrl: {
            required: true,
            type: String,
        },

        targetUrl: {
            type: String
        },

        canViewSalesTypes: {
            type: Boolean,
            required: true,
        },

        initialFilters: {
            required: false,
        },

        wltpStartYear: {
            type: Number,
        }
    },

    computed: {
        showCo2Wltp() {
            return this.filterYear >= this.wltpStartYear || this.filterComparisonYear >= this.wltpStartYear;
        },

        showCo2Nedc() {
            return this.filterYear < this.wltpStartYear || this.filterComparisonYear < this.wltpStartYear;
        },
    },

    methods: {
        loadGraphs() {
            _.each(this.sources, source => {
                source.loading = true;

                this.$http.get(source.url).then(response => {
                    this.reports[source.report] = response.data;
                    source.loading = false;
                });
            });

            this.$forceUpdate();
        },

        filter(filters) {
            this.$http.post(this.filterUrl, { filters: filters })
                .then((response) => {
                    this.loadGraphs();
                    bus.$emit('update-filter-string');
                    
                    _.defer(() => {
                        if (filters.registration.type == 'used-imports') {
                            this.showUsedOnlyGraphs = true;
                        } else {
                            this.showUsedOnlyGraphs = false;
                        }

                        if (filters.registration.type == 'new-imports') {
                            this.showNewImportGraphs = true;
                        } else {
                            this.showNewImportGraphs = false;
                        }
                    })
                })
        },

        goTo(location) {
            bus.$emit('show-loading-overlay');
            window.location = location ? this.targetUrl + '#' + location : this.targetUrl;
        },

        scrollToSection() {
            let target = window.location.href.match(/#(.*)/);
            let targetExists = target && target[0] != '#' && document.querySelectorAll(target[0]).length;

            if (target && targetExists) {
                VueScrollTo.scrollTo(target[0], 1000, { offset: -174 });
            }
        },

        exportToPdf() {
            this.graphImages = JSON.stringify(_.reject(_.map(this.$children, (child) => {
                if (child.isChartJs) {
                    if (this.showUsedOnlyGraphs) {
                        return {
                            itemType: 'chartJs',
                            title: child.title,
                            type: child.graphType,
                            dataset: child.graphType == 'pie' ? { data: child.datasets[0].data, colours: child.datasets[0].backgroundColor } : null,
                            labels: child.labels,
                            image: child.chart.toBase64Image()
                        };
                    } else {
                        if (! child.isUsedOnly) {
                            return {
                                itemType: 'chartJs',
                                title: child.title,
                                type: child.graphType,
                                dataset: child.graphType == 'pie' ? { data: child.datasets[0].data, colours: child.datasets[0].backgroundColor } : null,
                                labels: child.labels,
                                image: child.chart.toBase64Image()
                            };
                        }
                    }
                } else if (child.isHighMap) {
                    return {
                        itemType: 'highMap',
                        title: child.title,
                        image: child.getSVG()
                    };
                } else if (child.isStatBox) {
                    return {
                        itemType: 'statBox',
                        html: child.$el.innerHTML,
                    };
                }
            }), function (graph) {
                return graph == null;
            }));

            _.defer(() => {
                this.download = this.$refs.form.submit();
            })
        },
    }
}